import * as zod from "zod";

export const validationCartaoCredito = zod.object({
  parcelas: zod
    .string({ required_error: "O campo nome não pode ser vazio." })
    .max(191, { message: "O campo pode conter no máxiom 191 caracteres" })
    .min(1, { message: "O campo pode conter no mínimo 1 caracteres" }),
  numero_cartao: zod
    .string({ required_error: "O campo documento não pode ser vazio." })
    .max(191, { message: "O campo pode conter no máxiom 191 caracteres" })
    .min(1, { message: "O campo pode conter no mínimo 1 caracteres" }),
  cvv_cartao: zod
    .string({ required_error: "O campo telefone não pode ser vazio." })
    .max(4, { message: "O campo pode conter no máxiom 4 caracteres" })
    .min(3, { message: "O campo pode conter no mínimo 3 caracteres" }),
  cpf: zod
    .string({ required_error: "O campo telefone não pode ser vazio." })
    .max(191, { message: "O campo pode conter no máxiom 191 caracteres" })
    .min(1, { message: "O campo pode conter no mínimo 1 caracteres" }),
  nome: zod
    .string({ required_error: "O campo telefone não pode ser vazio." })
    .max(191, { message: "O campo pode conter no máxiom 191 caracteres" })
    .min(1, { message: "O campo pode conter no mínimo 1 caracteres" }),
  mes_cartao: zod
    .string({ required_error: "O campo telefone não pode ser vazio." })
    .max(191, { message: "O campo pode conter no máxiom 191 caracteres" })
    .min(1, { message: "O campo pode conter no mínimo 1 caracteres" }),
  ano_cartao: zod
    .string({ required_error: "O campo telefone não pode ser vazio." })
    .max(191, { message: "O campo pode conter no máxiom 191 caracteres" })
    .min(1, { message: "O campo pode conter no mínimo 1 caracteres" }),
});

export type formCartaoCredito = zod.infer<typeof validationCartaoCredito>;
